import React from 'react'
import { useTranslation } from 'react-i18next'

import { useLocks } from './_load/LocksLoader'
import EventsList from '../../../../nonComplianceV2/show/events/EventsList'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import { Paragraph } from '../../../../../packages/kiti/components/presentation/Text'

const LocksList = () => {
  const data = useLocks()
  const { t } = useTranslation('availability')

  return (
    <>
      {data.map(item => (
        <React.Fragment key={item.id}>
          <Separator weight={2} />
          {item.nonCompliance ? (
            <EventsList nonComplianceIds={item.nonCompliance.id} hideActionPlanButton disabled />
          ) : (
            // Locks can now originate from a manual action or an automation (not tied to a
            // checklist non-compliance), so `nonCompliance` may be null here.
            <Paragraph>
              {t(`origin.${item.origin || 'manual'}`)}
              {item.reason ? `: ${item.reason}` : ''}
            </Paragraph>
          )}
        </React.Fragment>
      ))}
    </>
  )
}

export default LocksList
